import { ToggleButton } from 'react-bootstrap';
import { UseControllerProps, useController } from 'react-hook-form';

import './style.scss';

const WEEK_DAYS: Array<{ bit: number; label: string }> = [
  { bit: 128, label: '月' },
  { bit: 64, label: '火' },
  { bit: 32, label: '水' },
  { bit: 16, label: '木' },
  { bit: 8, label: '金' },
  { bit: 4, label: '土' },
  { bit: 2, label: '日' },
  { bit: 1, label: '祝' },
];

export type WeekDayMaskControlProps = UseControllerProps<any>;

function WeekDayMaskControl(props: WeekDayMaskControlProps) {
  const {
    field: { value, onChange },
  } = useController(props);

  const mask: number = value ?? 0;

  function handleToggle(bit: number) {
    onChange(mask ^ bit);
  }

  return (
    <div className="week-day-mask-control" role="group">
      {WEEK_DAYS.map(({ bit, label }) => (
        <ToggleButton
          key={bit}
          id={`week-day-mask-${props.name}-${bit}`}
          type="checkbox"
          variant="outline-primary"
          className="week-day-mask-control__button"
          checked={(mask & bit) !== 0}
          value={bit}
          onChange={() => handleToggle(bit)}
        >
          {label}
        </ToggleButton>
      ))}
    </div>
  );
}

export default WeekDayMaskControl;
